//@ts-nocheck

'use client'

import React from "react";

import * as S from "./HeroSecondary.styles";

import { Container, Row, Col, SpacerBase } from "../../../atoms/GridSystem";
import { Paragraph, Heading } from "../../../atoms/Typography/Typography.component";
import Button from "../../../atoms/Button/Button.component";
import ItemsGrouped from "../../../molecules/ItemsGrouped/ItemsGrouped.component";
import "plyr-react/plyr.css"
import Image from "next/image";
import dynamic from "next/dynamic";

const HeroSecondary = ({ pretitle, title, paragraph, image, ctaPrimary, ctaSecondary, video }) => {
  const Plyr = video ? dynamic(() => import("plyr-react"), { ssr: false }) : null;

  return (
    <S.HeroSecondary>
      <Container>
        <Row>
          <Col xs={12} lg={5} $justify={'flex-end'}>
            { pretitle ? (
              <>
                <Paragraph {...pretitle} />
                <SpacerBase xs={.5} />
              </>
            ) : null}
            { title ? (
              <>
                <Heading {...title} />
                <SpacerBase xs={2} lg={2.5} />
              </>
            ) : null}
            { paragraph ? (
              <>
                <Paragraph typo={'paragraphMD'} content={paragraph} />
                <SpacerBase xs={3} />
              </>
            ) : null}
            { ctaPrimary || ctaSecondary ? (
              <ItemsGrouped 
                direction={{ xs: "column", xl: "row" }} 
                space={{ xs: 16, xl: 24 }} 
                fullWidth={['xs', 'sm', 'md']}
                justify={{ xs: "center", xl: "flex-start" }}
                align={{ xs: "flex-start", xl: "flex-start" }}
              >
                {ctaPrimary ? <Button {...ctaPrimary} variant="primary" iconEnd="arrow-right" /> : null}
                {ctaSecondary ? <Button {...ctaSecondary} variant="secondary" iconEnd="arrow-right" /> : null}
              </ItemsGrouped>
            ) : null}
          </Col>
        </Row>
      </Container>
      <S.HeroSecondaryImageWrapper>
        {video ? (
          <S.HeroSecondaryBackgroundVideo>
            {Plyr && <Plyr 
              source={{
                type: 'video',
                sources: [
                  {
                    src: video.url,
                    provider: 'html5',
                  },
                ],
                poster: image.url,
              }}
              options={{
                autoplay: true,
                muted: true,
                loop: { active: true },
                controls: false,
              }}
            />}
          </S.HeroSecondaryBackgroundVideo>
        ) : <Image {...image} fill />}
      </S.HeroSecondaryImageWrapper>
    </S.HeroSecondary>
  );
};

export default HeroSecondary;